// blue
export const BLUE = '#4C6291'; // theme.palette.text.secondary
export const DARK_BLUE = '#1c3863'; // theme.palette.primary.dark

// grey
export const BASE_GRAY = '#8992A7'; // theme.palette.grey[400]
export const LIGHT_GRAY = '#EBEAEB'; // theme.palette.grey[200]
